export default __webpack_public_path__ + "static/media/KingspanLogo.92e5e84d.svg";